// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__v_2Ib","controls":"styles_controls__Xj3cn","hidden":"styles_hidden__khBgU"};